"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeTableViewButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _lodash = _interopRequireDefault(require("lodash"));

var _treeChanges = _interopRequireDefault(require("tree-changes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ChangeTableViewButton =
/*#__PURE__*/
function (_Component) {
  _inherits(ChangeTableViewButton, _Component);

  function ChangeTableViewButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ChangeTableViewButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ChangeTableViewButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      changeTableViewVisible: false,
      columnsData: []
    });

    _defineProperty(_assertThisInitialized(_this), "changeTableView", function () {
      var columnsData = _this.state.columnsData;

      var savedFields = _this.getSavedFields();

      if (!_lodash["default"].isEqual(savedFields, columnsData)) {
        _this.setState({
          columnsData: savedFields
        });
      }

      _this.setState({
        changeTableViewVisible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSavedFields", function () {
      var _this$props = _this.props,
          savedViews = _this$props.savedViews,
          tabType = _this$props.tabType;

      var savedViewsForCurrentTabType = _lodash["default"].find(savedViews, {
        tabType: tabType
      });

      var savedFields = [];

      if (savedViewsForCurrentTabType) {
        savedFields = savedViewsForCurrentTabType.filterData.length > 0 ? savedViewsForCurrentTabType.filterData.split(',') : [];
      }

      return savedFields;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeTableViewOk", function () {
      var _this$props2 = _this.props,
          savedViews = _this$props2.savedViews,
          userName = _this$props2.userName,
          tabType = _this$props2.tabType,
          saveCustomTableViews = _this$props2.saveCustomTableViews;
      var columnsData = _this.state.columnsData;
      var entryToUpdate;

      var savedViewsForCurrentTabType = _lodash["default"].find(savedViews, {
        tabType: tabType
      });

      if (savedViewsForCurrentTabType) {
        savedViewsForCurrentTabType.filterData = columnsData.toString();
        savedViewsForCurrentTabType.userName = userName;
        entryToUpdate = savedViewsForCurrentTabType;
      } else {
        entryToUpdate = {
          userName: userName,
          tabType: tabType,
          filterData: columnsData.toString()
        };
      }

      saveCustomTableViews(entryToUpdate);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeTableViewCancel", function () {
      _this.setState({
        changeTableViewVisible: false,
        columnsData: _this.getSavedFields(),
        isError: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectedFieldChange", function (checkBox) {
      var columnsData = _this.state.columnsData;
      var item = checkBox.target;

      if (item.checked && _lodash["default"].includes(columnsData, item.value)) {
        columnsData.splice(columnsData.indexOf(item.value), 1);
      }

      if (!item.checked && !_lodash["default"].includes(columnsData, item.value)) {
        columnsData.push(item.value);
      }

      _this.setState({
        columnsData: columnsData
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAll", function (checkBox) {
      var item = checkBox.target;

      if (item.checked) {
        _this.setState({
          columnsData: []
        });
      } else {
        var allColumns = _this.getAllColumnNamesFromProps();

        _this.setState({
          columnsData: allColumns
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getAllColumnNamesFromProps", function () {
      var columns = _this.props.columns;
      var allColumns = [];
      columns.map(function (col) {
        return allColumns.push(col.dataIndex);
      });
      return allColumns;
    });

    return _this;
  }

  _createClass(ChangeTableViewButton, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState({
        columnsData: this.getSavedFields()
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var propsChanges = (0, _treeChanges["default"])(prevProps, this.props);
      var tabType = this.props.tabType;

      if (tabType !== prevProps.tabType) {
        this.setState({
          columnsData: this.getSavedFields()
        });
      }

      if (propsChanges.changed("saveError")) {
        this.setState({
          isError: this.props.saveError
        });
      }

      if (propsChanges.changedFrom("saveIsFetching", true, false)) {
        this.setState({
          isError: undefined,
          changeTableViewVisible: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          translate = _this$props3.translate,
          columns = _this$props3.columns;
      var _this$state = this.state,
          columnsData = _this$state.columnsData,
          changeTableViewVisible = _this$state.changeTableViewVisible;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_antd.Tooltip, {
        title: translate('filterForm/ChangeTableViewButton')
      }, _react["default"].createElement(_antd.Button, {
        type: "primary",
        className: "change-view",
        icon: "filter",
        onClick: function onClick() {
          return _this2.changeTableView();
        },
        style: {
          fontSize: '12px',
          marginRight: '6px',
          backgroundColor: columnsData.length === 0 ? '' : '#ffc107',
          borderColor: columnsData.length === 0 ? '' : '#ffc107'
        }
      }, translate("filter/buttonText/tableFilter"))), _react["default"].createElement(_antd.Modal, {
        title: translate('filterForm/SelectColumnsToHide'),
        visible: changeTableViewVisible,
        onOk: this.handleChangeTableViewOk,
        onCancel: this.handleChangeTableViewCancel,
        style: {
          marginTop: '15%'
        },
        footer: [_react["default"].createElement(_antd.Button, {
          key: "back",
          style: {
            fontSize: '12px'
          },
          onClick: this.handleChangeTableViewCancel
        }, _react["default"].createElement(_antd.Icon, {
          type: "rollback"
        }), translate("filterForm/Return")), _react["default"].createElement(_antd.Button, {
          key: "apply",
          type: "primary",
          style: {
            fontSize: '12px'
          },
          disabled: this.getAllColumnNamesFromProps().length === columnsData.length,
          onClick: this.handleChangeTableViewOk
        }, _react["default"].createElement(_antd.Icon, {
          type: "check-circle-o"
        }), translate("filterForm/Apply"))]
      }, this.state.isError === false && _react["default"].createElement(_antd.Alert, {
        message: translate('filterForm/CustomTableViewChangeSuccess'),
        type: "success",
        style: {
          fontSize: '12px'
        }
      }), this.state.isError === true && _react["default"].createElement(_antd.Alert, {
        message: translate('filterForm/CustomTableViewChangeError'),
        type: "error",
        style: {
          fontSize: '12px'
        }
      }), _react["default"].createElement(_antd.Checkbox, {
        onChange: this.handleSelectAll,
        checked: columnsData.length === 0
      }, translate('filterForm/SelectAll')), _react["default"].createElement("br", null), _react["default"].createElement("br", null), changeTableViewVisible && columns && columns.map(function (col) {
        return _react["default"].createElement("div", {
          key: col.dataIndex
        }, _react["default"].createElement(_antd.Checkbox, {
          value: col.dataIndex,
          onChange: _this2.handleSelectedFieldChange,
          defaultChecked: !_lodash["default"].includes(columnsData, col.dataIndex),
          checked: !_lodash["default"].includes(columnsData, col.dataIndex)
        }, typeof col.title.props.column.title === 'string' ? translate(col.title.props.column.title) : translate(col.title.props.column.title.props.title)));
      })));
    }
  }]);

  return ChangeTableViewButton;
}(_react.Component);

exports.ChangeTableViewButton = ChangeTableViewButton;